exports = module.exports = require("../../../../css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".erg-components-DropdownFilter{display:inline-block;margin-top:-1px}.erg-components-DropdownFilter .dropdown{margin-top:-1px}.erg-components-DropdownFilter .dropdown button{padding:0!important;box-shadow:none}", "", {"version":3,"sources":["/./node_modules/@ergeon/erg-components-react/lib/filters/node_modules/@ergeon/erg-components-react/lib/filters/DropdownFilter.scss"],"names":[],"mappings":"AAAA,+BACE,qBACA,eAAgB,CAFlB,yCAII,eAAgB,CAJpB,gDAMM,oBACA,eAAgB,CACjB","file":"DropdownFilter.scss","sourcesContent":[".erg-components-DropdownFilter {\n  display: inline-block;\n  margin-top: -1px;\n  .dropdown {\n    margin-top: -1px;\n    button {\n      padding: 0 !important;\n      box-shadow: none;\n    }\n  }\n}\n"],"sourceRoot":"webpack://"}]);

// exports



/*****************
 ** WEBPACK FOOTER
 ** ./~/css-loader?sourceMap!./~/sass-loader?sourceMap&includePaths[]=/home/circleci/project/bower_components&includePaths[]=/home/circleci/project/node_modules!./~/postcss-loader!./~/@ergeon/erg-components-react/lib/filters/DropdownFilter.scss
 ** module id = 1153
 ** module chunks = 0
 **/